// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CampaignsPage_wrapper__2A1cG"};